import { useMemo } from 'react';

import { useParams } from '../../container/Router';
import {
    Features,
    useFeatureFlagValue,
} from '../FeatureFlagUtil';

export default function useIsDirectBuy() {
    const params = useParams();
    const { EnableEcommerceDirectBuy } = useFeatureFlagValue([ Features.EnableEcommerceDirectBuy ]);

    return useMemo(() => EnableEcommerceDirectBuy && !!params.direct_buy_sku, [ EnableEcommerceDirectBuy, params ]);
}
